<template>
    <div class="wrapper">
      <div class="topo-header centro">
        <botao-voltar nomeRota="StatusMandato" />
        <h1>{{ statusMandatoForm.id ? "Editar" : "Novo" }} Status do Mandato</h1>
      </div>
      <div class="tab-dados-basicos">
        <div class="form centro">
          <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
          <p class="texto-asterisco">Os campos com asterisco (*) são de preenchimento obrigatório.</p>
          <form @submit.prevent="enviarForm">
            <div class="caixa-form">
              <div class="flexbox">
                <div class="item">
                    <label><b>{{ possuiAsterisco("Nome:") }}</b></label>
                    <input type="text" placeholder="Digite o nome" v-model="statusMandatoForm.nome" />
                </div>
                <div class="item">
                    <label><b>{{ possuiAsterisco("Código:") }}</b></label>
                    <input type="number" min="1" max="9" v-model="statusMandatoForm.codigo" @input="inRange(statusMandatoForm.codigo)"  placeholder="Digite o código" />
                </div>
                <div class="item">
                    <div class="radio">
                    <label class="radio-label"><b>{{ possuiAsterisco("Ativo") }}</b></label>
                    <div class="radio-item">
                        <label for="sim-ativo-status">Sim</label>
                        <input type="radio" id="sim-ativo-status" name="radioOptions" value="true" v-model="statusMandatoForm.ativo">
                        <label for="nao-ativo-status">Não</label>
                        <input type="radio" id="nao-ativo-status" name="radioOptions" value="false" v-model="statusMandatoForm.ativo">
                    </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="bt-salvar">
              <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                <img id="spinner-loading" class="spinner-loading" src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                <p id="conteudo-botao">{{ statusMandatoForm.id ? "Atualizar" : "Criar" }}</p>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import StatusMandatoApi from '../../services/StatusMandatoApi';
  import BotaoVoltar from '../../components/BotaoVoltar.vue';
  import MsgErroFormularios from '../MsgErroFormularios';
  
  export default {
    name: 'StatusMandatoForm',
    props: {
      statusMandato: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {
        erro: false,
        msgErros: {
          codigo: '',
          nome: '',
          ativo: '',
          default: '',
        },
        statusMandatoApi: new StatusMandatoApi(),
        statusMandatoForm: this.statusMandato
          ? {
              id: this.statusMandato.id,
              codigo: this.statusMandato.codigo,
              nome: this.statusMandato.nome,
              ativo: this.statusMandato.ativo,
            }
          : {
              id: null,
              codigo: null,
              nome: null,
              ativo: null,
            },
      };
    },
    components: {
      BotaoVoltar,
      MsgErroFormularios,
    },
    methods: {
      async enviarForm() {
        try {
          const flag = this.validarForm(this.statusMandatoForm);
          if (flag === 1) {
            this.erro = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
  
          const data = await this.statusMandatoApi.setStatusMandato(this.statusMandatoForm);
  
          // Redirecionar para a rota de visualização após a submissão bem-sucedida
          this.$router.push({
            name: 'StatusMandatoShow',
            params: {
              id: data.id,
            },
          });
        } catch (err) {
          console.error(err);
          this.erro = true;
          const { response } = err;
          if (response && response.data) {
            this.msgErros = response.data;
          } else {
            this.msgErros = 'Houve um erro ao salvar o registro. Por favor, tente novamente.';
          }
        }
      },
      validarForm(statusMandatoForm) {
        let flag = 0;
        this.msgErros = {
          codigo: '',
          nome: '',
          ativo: '',
          default: '',
        };
  
        if (!statusMandatoForm.codigo) {
          this.msgErros.codigo = 'O campo código não foi preenchido.';
          flag = 1;
        }
        if (!statusMandatoForm.nome) {
          this.msgErros.nome = 'O campo nome não foi preenchido.';
          flag = 1;
        }
        if (statusMandatoForm.ativo === null) {
            this.msgErros.ativo = 'O campo ativo não foi selecionado.';
            flag = 1;
        }
  
        return flag;
      },
      possuiAsterisco(texto) {
        return '* ' + texto;
      },
      fecharErro() {
        this.erro = false;
      },
      inRange(codigo) {
                let divMensagem = document.getElementById("mensagem");

                if (codigo > 9 || codigo <= 0) {
                    divMensagem.style.display = "block"
                }

                if (codigo <= 9 && codigo > 0) {
                    divMensagem.style.display = "none"
                }

                if(codigo == '') {
                    divMensagem.style.display = "none"
                }
     },
    },
  };
  </script>  
  
<style lang="scss" scoped>

@import "../../styles/catalogoForm.scss";

.wrapper .form.centro p.texto-asterisco {
  color: #005516 !important;
  font-size: 0.9rem !important;
  margin-bottom: 1rem !important;
  font-family: "Montserrat-Medium", sans-serif !important;
}
</style>
